
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lessons/components/VideoCard",
      function () {
        return require("private-next-pages/lessons/components/VideoCard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lessons/components/VideoCard"])
      });
    }
  